const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const ImageLoadSwitch = require("./ImageLoadSwitch");

const styles = require("./styles/ComputerScreenshot.css");

module.exports = createReactClass({
	displayName: "ComputerScreenshot",

	propTypes: {
		screenshotType: PT.string,
		alt: PT.string,
		computerType: PT.oneOf([
			"laptop",
			"laptop-black",
			"tablet",
			"tablet-black",
		]),
		className: PT.string,
		extraChildren: PT.arrayOf(PT.object),
	},

	getDefaultProps: function() {
		return {
			alt: "",
			screenshotType: "block-page",
			computerType: "laptop",
		};
	},

	render: function() {
		const computerType = this.props.computerType;
		const screenshotType = this.props.screenshotType;

		const baseSrc =
			global.BASE_URL +
			"assets/images/office/elements/screenshots/" +
			screenshotType;

		const screenImg = (
			<ImageLoadSwitch
				className={styles[computerType]}
				alt={this.props.alt}
				imageSrc={baseSrc + ".png"}
				fallbackImageSrc={baseSrc + ".jpg"}
			/>
		);

		return (
			<div
				className={styles.mainContainer + " " + (this.props.className || "")}
			>
				<div className={styles.main}>
					<div className={styles["fallback-" + computerType]} />
					{this.props.extraChildren}
					<img
						className={styles.image}
						alt="Laptop Computer"
						src={
							global.BASE_URL +
							"assets/images/office/elements/" +
							computerType +
							".svg"
						}
					/>
					{screenImg}
				</div>
			</div>
		);
	},
});
